export const qagentHome = {
  header: {
    resources: 'Resources',
    recentChats: 'Recent chats',
  },
  greeting: {
    welcome: (firstName: string) => `Welcome, ${firstName}`,
    fallback: 'Hello there',
    subtitle: 'What legal matters are we tackling today?',
  },
  prompts: {
    firstDraft: {
      label: 'First draft',
      tooltip: 'Draft a new contract or legal document from scratch',
    },
    reviewContract: {
      label: 'Review a contract',
      prompt: 'Review this document for potential issues and risks',
    },
    checkCompliance: {
      label: 'Check compliance',
      prompt: 'Check this document for GDPR compliance issues',
    },
    suggestImprovements: {
      label: 'Suggest improvements',
      prompt:
        'Suggest improvements to strengthen the legal language in this document',
    },
    askQuestion: {
      label: 'Ask a question',
      prompt: 'What are the key terms and obligations in this document?',
    },
  },
  input: {
    placeholder: 'Message QAgent...',
    addProjectContext: 'Add project context',
    noProjectsYet: 'No projects yet',
    fileCount: (count: number) => `${count} file${count !== 1 ? 's' : ''}`,
    hasChat: ' · has chat',
  },
  dropZone: {
    attachToProject: (projectName: string) => `Drop to attach to ${projectName}`,
    attachToProjectFallback: 'Drop to attach to project',
    startNewProject: 'Drop to start a new project',
  },
  linkPlaybookDialog: {
    title: 'Link Playbook',
    description: 'Select a playbook to link to this project.',
    playbookLabel: 'Playbook',
    selectPlaceholder: 'Select a playbook',
    noAvailablePlaybooks: 'No available playbooks',
    linking: 'Linking...',
    submit: 'Link Playbook',
  },
  deleteFileDialog: {
    title: 'Delete File',
    description: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    deleting: 'Deleting...',
  },
  unlinkPlaybookDialog: {
    title: 'Unlink Playbook',
    description: (name: string) =>
      `Are you sure you want to unlink "${name}" from this project?`,
    unlinking: 'Unlinking...',
    confirm: 'Unlink',
  },
  toasts: {
    createProjectFailed: 'Failed to create project',
    playbookLinkedSuccess: 'Playbook linked successfully',
    linkPlaybookFailed: 'Failed to link playbook',
    linkError: 'Error linking playbook',
    fileDeleted: (name: string) => `File "${name}" deleted`,
    deleteFileFailed: 'Failed to delete file',
    deleteError: 'Error deleting file',
    playbookUnlinked: (name: string) => `Playbook "${name}" unlinked`,
    unlinkPlaybookFailed: 'Failed to unlink playbook',
    unlinkError: 'Error unlinking playbook',
    startContractFailed: 'Failed to start contract',
  },
  generateDialog: {
    title: 'Draft a new document',
    description: "Tell QAgent what to draft. You can refine it after it's generated.",
    docTypeLabel: 'Document type',
    docTypePlaceholder: 'e.g., NDA, Employment Agreement, Service Contract',
    descriptionLabel: 'Description',
    descriptionOptional: '(optional)',
    descriptionPlaceholder:
      'Key requirements, terms, jurisdiction, special clauses...',
    playbookLabel: 'Playbook',
    noPlaybook: 'No playbook',
    playbookMeta: (agreementType: string, ruleCount: number) =>
      `${agreementType} • ${ruleCount} ${ruleCount === 1 ? 'rule' : 'rules'}`,
    starting: 'Starting...',
    submit: 'Start drafting',
    docTypeSuggestions: {
      nda: 'NDA',
      employmentAgreement: 'Employment Agreement',
      serviceContract: 'Service Contract',
      consultingAgreement: 'Consulting Agreement',
    },
  },
  chatHistory: {
    title: 'Chat History',
    description: 'Your recent conversations with QAgent',
    loading: 'Loading...',
    noConversations: 'No conversations yet',
    startFromHome: 'Start a new chat from the home screen',
    untitledChat: 'New Chat',
    messageCount: (count: number) => `${count} message${count !== 1 ? 's' : ''}`,
    deleteChat: 'Delete chat',
  },
};

export type QagentHomeDict = typeof qagentHome;
